import React from "react";
import "./NumberInput.css";
import CustomError from "../Errors/CustomError";
import Asterisks from "../Asterisks/Asterisks";

const NumberInput = ({
  label,
  name,
  value = "",
  onChange,
  parentClassName = "",
  inputClassName = "",
  labelClassName = "",
  placeholder = "Enter number",
  parentStyle = {},
  inputStyle = {},
  labelStyle = {},
  maxLength,
  minLength,
  step,
  readOnly = false,
  disabled = false,
  required = false,
  autocomplete = "off",
  customError,
  asterisk,
  onBlur,
}) => {
  const handleChange = (e) => {
    let inputValue = e.target.value;

    // Allow only numeric values (0-9) and dot if name is "inward_qty"
    if (
      name === "inward_qty" ||
      name === "provision_qty" ||
      name === "outward_qty" ||
      name === "mrb_qnty" ||
      name === "scrab_qty" ||
      name === "unit_rate"
    ) {
      if (!/^(\d+\.?\d*|\.\d+)?$/.test(inputValue)) {
        return;
      }
    } else {
      if (!/^\d*$/.test(inputValue)) {
        return;
      }
    }

    // Prevent empty input from breaking logic
    if (inputValue === "") {
      inputValue = ""; 
    }

    onChange({ target: { name: e.target.name, value: inputValue } });
  };

  const handleKeyDown = (e) => {
    if (
      name === "inward_qty" ||
      name === "provision_qty" ||
      name === "outward_qty" ||
      name === "mrb_qnty" ||
      name === "scrab_qty" ||
      name === "unit_rate"
    ) {
      // Allow digits, dot, and control keys for inward_qty
      if (
        !/^\d$/.test(e.key) &&
        e.key !== "." &&
        !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(
          e.key
        )
      ) {
        e.preventDefault();
      }
    } else {
      // Original behavior for other fields
      if (
        !/^\d$/.test(e.key) &&
        !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(
          e.key
        )
      ) {
        e.preventDefault();
      }
    }
  };

  return (
    <div
      className={
        parentClassName && parentClassName.trim() !== ""
          ? parentClassName
          : "default-number-parent-class"
      }
      style={parentStyle}>
      <label
        className={
          labelClassName && labelClassName.trim() !== ""
            ? labelClassName
            : "default-number-label-class"
        }
        style={labelStyle}>
        {label} <Asterisks asterisk={asterisk} />
      </label>
      <div className="number-input-wrapper">
        <input
          name={name}
          type="text"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className={`${
            inputClassName && inputClassName.trim() !== ""
              ? inputClassName
              : "default-number-input-class"
          } ${customError ? "number-input-error" : ""}`}
          style={inputStyle}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          onBlur={onBlur}
          autoComplete={autocomplete}
        />
        {customError && (
          <i className="fas fa-exclamation-circle number-error-icon"></i>
        )}
      </div>
      {customError && <CustomError error={customError} />}
    </div>
  );
};

export default NumberInput;
